import Vue from "vue";
import Component from "vue-class-component";
import { modalHelper, IModalBase, DataItem, alertHelper } from "@/components";
import { Deferred } from "@/utils/Deferred";
import { usersStore } from "../store/users.store";
import { Prop, Watch } from "vue-property-decorator";
import map from "./map.vue";
import { istatStore } from '@/modules/domains';
import { Async } from '@/utils/AsyncDecorators';
import { accountService } from '@/services/accountService';

@Component({})
export default class Invite extends Vue implements IModalBase<server.auth.invite> {
  @Prop()
  value: server.auth.invite;

  @Prop()
  deferred: Deferred<DataItem<server.auth.invite>>;
  msg: string = '';

  mounted() {
    setTimeout(this.validateForm, 2000); 
  }

  cancel() {
    modalHelper.Unchanged(this);
    modalHelper.closeModal("extended");
  }

  async ok() {
    await accountService.Invite(this.value);
    modalHelper.Changed(this);
  }

  formIsValid: boolean = false;
  validateForm() {
    this.formIsValid = (this.$refs.form && (this.$refs.form as any).checkValidity())
  }
}